import React from 'react';
import { AppButton, Box, Inscription, List, Preloader, Text } from '@common-fe/common-fe';

import { Modal } from '@/components';
import { CategoryItem, ServiceItem } from '@/modules/ProcessingDefinition/Services/Services.types';
import theme from '@/styles/theme';

import CategoryRowContainer from '../CategoryRow.container';
import { CheckState } from '../hooks';

interface AddServicesModalProps {
  visible: boolean;
  categories: CategoryItem[];
  isCategoriesLoading: boolean;
  totalSelected: number;
  isAnyLoading: boolean;
  getCategoryCheckState: (categoryType: string) => CheckState;
  isServiceSelected: (categoryType: string, serviceId: string) => boolean;
  onToggleCategory: (category: CategoryItem, allServices?: ServiceItem[]) => void;
  onToggleService: (categoryType: string, service: ServiceItem) => void;
  onStartLoading: () => void;
  onEndLoading: () => void;
  onClose: () => void;
  onSubmit: () => void;
}

const AddServicesModal: React.FC<AddServicesModalProps> = ({
  visible,
  categories,
  isCategoriesLoading,
  totalSelected,
  isAnyLoading,
  getCategoryCheckState,
  isServiceSelected,
  onToggleCategory,
  onToggleService,
  onStartLoading,
  onEndLoading,
  onClose,
  onSubmit,
}) => {
  return (
    <Modal visible={visible} onSetVisible={onClose} isClosingByClickOutsideBlocked>
      <Box direction="column" gap="spacing24">
        <Box direction="row" align="center" justify="center">
          <Text size="2xl" color="textTitle" weight="bold">
            Add Services
          </Text>
        </Box>

        <Box background="module" round="moduleRound" pad="spacing24" style={{ overflow: 'visible' }}>
          <List.Header margin={{ bottom: 'spacing12' }} height="36px">
            <List.Header.Item style={{ width: '100%', paddingLeft: theme.spacings.spacing24 }}>
              <Inscription size="12px" weight="bold" lineHeight="18px">
                Category name
              </Inscription>
            </List.Header.Item>
          </List.Header>

          {isCategoriesLoading ? (
            <Box pad="spacing24" align="center">
              <Preloader testId="add-services-modal_categories-loading" />
            </Box>
          ) : (
            <Box gap="spacing4">
              {categories.map((category) => (
                <CategoryRowContainer
                  key={category.id}
                  category={category}
                  checkState={getCategoryCheckState(category.name)}
                  isServiceSelected={(serviceId) => isServiceSelected(category.name, serviceId)}
                  onToggleCategory={(category, allServices) => onToggleCategory(category, allServices)}
                  onToggleService={(service) => onToggleService(category.name, service)}
                  onStartLoading={onStartLoading}
                  onEndLoading={onEndLoading}
                />
              ))}
            </Box>
          )}
        </Box>

        <Box direction="row" align="center" justify="end" gap="s">
          <AppButton
            testId="add-services-modal_cancel-button"
            buttonType="secondary"
            width="control"
            onClick={onClose}
          >
            Cancel
          </AppButton>
          <AppButton
            testId="add-services-modal_submit-button"
            width="control"
            onClick={onSubmit}
            disabled={totalSelected === 0 || isAnyLoading}
          >
            {isAnyLoading ? <Preloader color="white" /> : 'Add Services'}
          </AppButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddServicesModal;
